<template>
  <div>
    <v-dialog
      v-model="v_announ"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
      max-width="500px"
    >
      <v-card class="rounded_max">
        <v-toolbar dense flat>
          <h3>Announcement</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 py-0" v-if="inventory">
          <v-container style="height: max-content">
            <div class="d-flex justify-end align-center">
              <p class="default_txt">
                {{ $date(inventory.created_at).format("dddd, DD MMMM YYYY") }}
              </p>
            </div>
            <h2 class="text-center mb-2">{{ inventory.title }}</h2>
            <p
              class="default_txt text-justify"
              v-if="inventory.description"
              v-html="inventory.description"
            ></p>
            <p class="default_txt" v-else>No Description</p>
            <img :src="inventory.foto" width="100%" alt="" />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="$emit('close')">
            Close
          </v-btn>
        </v-card-actions>
        <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
          <v-progress-circular
            indeterminate
            class="mr-2"
            color="#006341"
          ></v-progress-circular>
          <b class="color_default">Loading...</b>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "createAnnoun",
  props: ["v_announ", "inventory"],
  computed: {
    getYear() {
      let data = [];
      let year = parseInt(this.$date().format("YYYY"));
      for (let i = 2019; i <= year; i++) {
        data.push({
          state: i,
          abbr: i,
        });
      }
      data.push({
        state: "All Scholar",
        abbr: "all",
      });
      return data;
    },
  },
  data() {
    return {
      loading: false,
      content: "",
      body: {
        title: "",
        description: "",
        image: null,
        year_tf: "all",
      },
      picture: "",
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }],
      ],
    };
  },
  methods: {
    createData() {
      this.loading = true;
      let body = new FormData();
      for (let key in this.body) {
        body.append(key, this.body[key]);
      }
      let data = {
        path: `announcement/create`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          for (let key in this.body) {
            if (key == "image") {
              this.body[key] = "";
            } else {
              this.body[key] = "";
            }
          }
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("close");
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    upload(e) {
      const file = e.target.files[0];
      const fr = new FileReader();
      fr.onload = (f) => {
        this.picture = f.target.result;
      };
      fr.readAsDataURL(file);
      this.body.image = file;
    },
  },
};
</script>

<style scoped>
.input_hide {
  display: none;
}
.title_f {
  border: solid 1px #cccccc;
  width: 100%;
  border-radius: 8px;
  /* height: 35px; */
  padding: 8px 10px;
  margin-bottom: 10px;
}
.title_f:focus {
  outline: none;
}
</style>
